export const MODAL_DONE_BUTTON_ID = 'modal__done-button';
export const MODAL_CLOSE_BUTTON_ID = 'modal__close-button';
export const MODAL_CUSTOM_CLOSE_BUTTON_ID = 'modal__custom-close-button';
export const MODAL_OVERLAY_ID = 'modal__overlay';
